var createGetFormNames = function createGetFormNames(_ref) {
  var getIn = _ref.getIn,
      keys = _ref.keys;
  return function () {
    var getFormState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      return keys(getFormState(state));
    };
  };
};

export default createGetFormNames;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/selectors/getFormNames.js
// module id = 1944
// module chunks = 1